module.exports = "pegasus/assets/preview-17.png";